// Standard
//import "bootstrap"; // nicht so! nur importieren, was wir brauchen
import $ from "jquery";
//so:
//import Alert from 'bootstrap/js/dist/alert'
// or, specify which plugins you need:
import { Navbar, Modal, Badge, Dropdown, Popover, Alert} from 'bootstrap'


// Modules
import "./modules/module-hero-swiper/module-hero-swiper.js";  
import "./modules/module-news-swiper/module-news-swiper.js";  
import "./modules/module-immo-swiper/module-immo-swiper.js";
import "./modules/module-project-swiper/module-project-swiper.js";
import "./modules/module-service-finder/module-service-finder.js";
import "./modules/module-warning/module-warning.js";
// Custom
import "./custom.js";